const payments = {
    state: {
        from: null,
        to: null
    },
    getters: {
        getFrom(state) {
            return state.from;
        },
        getTo(state) {
            return state.to;
        }
    },
    mutations: {
        setFrom(state, from) {
            state.from = from;
        },
        setTo(state, to) {
            state.to = to;
        }
    },
    actions: {
        setCurrentFrom({ commit }, from) {
            commit('setFrom', from);
        },
        setCurrentTo({ commit }, to) {
            commit('setTo', to);
        }
    }
};

export default payments;
